import React, { FC, useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

// REDUX
import { useAppSelector, useAppDispatch } from '@Managers/Redux/Hooks';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { getCasinoMenu, getDeviceInfo, getPopClient } from '@Managers/Redux/AppState/AppState';
import { CASINO_MENU_ITEM_DEFAULT, TCasinoMenuItem } from '@Managers/Redux/AppState/AppState.types';
import { quitAction } from '@Managers/Redux/HttpState';

// TYPES
import { DOM_ID } from '@UILayer/UILayer.types';

// STYLES
import style from '@UILayer/UILayer.scss';

// IMAGES
import warningIcon from './warning_icon.svg';

import { Button } from '@UILayer/Inputs/Button';

export const MessageLogoutConfirmation: FC<{ onClose: Function }> = ({ onClose }) => {
    const [state, setState] = useReducer((state: TCasinoMenuItem, newState: any) => ({ ...state, ...newState }), CASINO_MENU_ITEM_DEFAULT);

    const dispatch = useAppDispatch();
    const casinoData = useAppSelector(getCasinoMenu);
    const popClientconfig = useAppSelector(getPopClient);
    const device = useAppSelector(getDeviceInfo);
    const { t } = useTranslation();

    useEffect(() => {}, []);

    function closeWindow() {
        onClose();
    }

    useEffect(() => {
        if (casinoData && casinoData.lobby) {
            setState({ url: casinoData.lobby?.url, title: casinoData.lobby?.title, active: true });
        }
    }, [casinoData]);

    const logoutAction = () => {
        if (popClientconfig.enabled && popClientconfig.initialized) EventsCenter.emit(EGameEvents.CLOSE_GAME_FRAME_COMMAND);

        dispatch(quitAction());

        if (state.url) {
            window.open(state.url, '_top');
        } else {
            window.close();
        }
    };

    return (
        <>
            <div className={`${style.message_icon} ${style.message_icon_error}`}>
                <img src={warningIcon} alt="" />
            </div>
            <div className={style.message_header}>{t('POPUP_MESSAGE_LOGOUTCONFIRMATION_MESSAGE')}</div>
            <div className={style.message_desc}></div>
            <div className={style.message_actions}>
                <Button
                    id={DOM_ID.BUTTON_POPUP_MESSAGE_LOGOUT_ACCEPT}
                    description={t(`POPUP_MESSAGE_LOGOUTCONFIRMATION_BUTTON_ACCEPT`)}
                    className={cn(style.popup_btn)}
                    onChange={() => logoutAction()}
                    dataDismiss="modal"
                >
                    {t('POPUP_MESSAGE_LOGOUTCONFIRMATION_BUTTON_ACCEPT')}
                </Button>

                <Button
                    id={DOM_ID.BUTTON_POPUP_MESSAGE_LOGOUT_DECLINE}
                    description={t(`POPUP_MESSAGE_LOGOUTCONFIRMATION_BUTTON_DECLINE`)}
                    className={cn(style.popup_btn)}
                    onChange={() => closeWindow()}
                    dataDismiss="modal"
                >
                    {t('POPUP_MESSAGE_LOGOUTCONFIRMATION_BUTTON_DECLINE')}
                </Button>
            </div>
        </>
    );
};
